import React from 'react'
import Icon from 'src/components/common/Icon';
import { NotFoundMessage } from './Prospects404.styles';

export const Prospects404 = () => {
    return (
        <NotFoundMessage>
            <Icon disableFill icon="pcom-icon-warning-outline" size={64} />
            No se encontraron prospectos para esta sección
        </NotFoundMessage>
    )
}
